import Vue from 'vue';

const requirePlugin = require.context('./modules', true, /\.js$/);
requirePlugin.keys().forEach(key => {
  if (requirePlugin(key).default && requirePlugin(key).default.install) {
    Vue.use(requirePlugin(key).default);
  }
});
